
export enum StatusesTypes{
    Quote = 'Quote',
    Client = 'Client',
    Project = 'Project',
    QuoteJob = 'Quote Job',
    Job = 'Job',
    PurchaseOrder = 'PO',
    Invoice = 'Invoice'
}